
import React, { useState } from "react";
import "./JobApplication.css";

function JobApplication() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(
    () =>
      new URLSearchParams(window.location.search).get(
        "application"
      ) === "success"
  );

  const positions = [
    "Frontend Developer (React.js)",
    "Backend Developer (ASP.NET Core)",
    "Full Stack Developer",
    "UI/UX Designer",
    ".NET Trainer",
    "React/JavaScript Trainer",
    "SQL/Database Trainer",
    "Other",
  ];

  function submitAnotherApplication() {
    window.history.replaceState(
      {},
      "",
      window.location.pathname
    );

    setIsSubmitted(false);
    setIsFormOpen(true);
  }

  if (isSubmitted) {
    return (
      <section className="job-application application-success">
        <div className="success-icon">✓</div>

        <h2>Application Submitted Successfully!</h2>

        <p>
          Thank you for your interest in joining R3K.
          We appreciate your application.
        </p>

        <div className="success-actions">
          <button
            type="button"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Back to Home
          </button>

          <button
            type="button"
            onClick={submitAnotherApplication}
          >
            Submit Another Application
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="job-application">
      {!isFormOpen ? (
        <div className="application-intro">
          <h2>Ready to Apply?</h2>

          <p>
            Interested in joining R3K? Take the next step
            in your career by submitting your application.
          </p>

          <button
            type="button"
            onClick={() => setIsFormOpen(true)}
          >
            Fill Out Application Form
          </button>
        </div>
      ) : (
        <div className="application-form-container">
          <h2>Job Application Form</h2>

          <p>
            Please fill in your details and upload your resume.
          </p>

          <form
            action="https://formsubmit.co/contact@r3ktech.com"
            method="POST"
            encType="multipart/form-data"
          >
            <input
              type="hidden"
              name="_subject"
              value="New R3K Job Application"
            />

            <input
              type="hidden"
              name="_next"
              value={`${window.location.origin}${window.location.pathname}?application=success`}
            />

            <input
              type="text"
              name="_honey"
              style={{ display: "none" }}
              tabIndex="-1"
              autoComplete="off"
            />

            <input
              type="text"
              name="Full Name"
              placeholder="Full Name"
              autoComplete="name"
              required
            />

            <input
              type="email"
              name="Email"
              placeholder="Email Address"
              autoComplete="email"
              required
            />

            <input
              type="tel"
              name="Mobile Number"
              placeholder="10-digit Mobile Number"
              autoComplete="tel"
              pattern="[0-9]{10}"
              maxLength={10}
              title="Enter a valid 10-digit mobile number"
              required
            />

            <select
              name="Position Applying For"
              defaultValue=""
              required
            >
              <option value="" disabled>
                Select Position
              </option>

              {positions.map((position) => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>

            <label htmlFor="resume">
              Upload Resume (PDF, DOC or DOCX)
            </label>

            <input
              id="resume"
              type="file"
              name="attachment"
              accept=".pdf,.doc,.docx"
              required
            />

            <input
              type="text"
              name="Experience"
              placeholder="Experience (e.g. Fresher / 2 Years)"
              required
            />

            <input
              type="text"
              name="Education"
              placeholder="Education / Qualification"
              required
            />

            <textarea
              name="Message"
              placeholder="Tell us about yourself"
              rows="5"
            />

            <div className="form-buttons">
              <button type="submit">
                Submit Application
              </button>

              <button
                type="button"
                className="close-application-btn"
                onClick={() => setIsFormOpen(false)}
              >
                Close Form
              </button>
            </div>
          </form>
        </div>
      )}
    </section>
  );
}

export default JobApplication;
